import qs from 'qs'
import React, { useState } from 'react'
import { getImage } from '../../../components/helpers/FormatLinks'
import Page from '../../../components/page/Page'
import ReceivedTrades from '../../../components/trade/ReceivedTrades'
import SentTrades from '../../../components/trade/SentTrades'
import {
    BreadcrumbItem,
    Breadcrumbs,
    Tabs,
    Tab,
    Button,
} from '@nextui-org/react'
import cn from 'classnames'
import Link from 'next/link'
import { TradeBreadCrumbs } from '../../../components/trading/TradeBreadCrumbs'
import { useTranslation } from 'react-i18next'

const TradePage = (props) => {
    const ual = props['ual'] ? props['ual'] : { activeUser: null }

    const activeUser = ual['activeUser']

    let values = qs.parse(
        typeof window !== 'undefined'
            ? window.location.search.substring(1, window.location.search.length)
            : [],
    )

    const userName = activeUser ? activeUser['accountName'] : values['user']

    const image = getImage(userName)

    const { t } = useTranslation('common')

    return (
        <Page id="TradePage" image={image} banners={false} {...props}>
            <div className="mx-2 sm:mx-[4vw]">
                <div className="flex flex-1 flex-row justify-between items-center">
                    <div>
                        <TradeBreadCrumbs
                            items={[
                                {
                                    href: '/trade',
                                    name: t('navigation.trading'),
                                },
                                {
                                    href: '/trade/new',
                                    name: t('trading.received_trade_offers'),
                                },
                            ]}
                        />

                        <h2 className="text-2xl xs1:text-3xl sm:text-4xl dark:text-white text-black mb-4 mt-4">
                            {t('trading.received_trade_offers')}
                        </h2>
                    </div>
                </div>

                <div className="flex w-full flex-col mt-4">
                    <ReceivedTrades tabKey={'received-offers'} />
                </div>
            </div>
        </Page>
    )
}

export default TradePage
